import { useEffect, useState } from "react";
import { getTenantSettings } from "../APIs/TenantSettingsAPI";

const timeToMinutes = (value) => {
  if (!value || typeof value !== "string") return null;

  const raw = value.trim().toUpperCase();

  const twentyFourHourMatch = raw.match(/^(\d{1,2}):(\d{2})$/);
  if (twentyFourHourMatch) {
    const hours = Number(twentyFourHourMatch[1]);
    const minutes = Number(twentyFourHourMatch[2]);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
    return hours * 60 + minutes;
  }

  const twelveHourMatch = raw.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/);
  if (twelveHourMatch) {
    let hours = Number(twelveHourMatch[1]);
    const minutes = Number(twelveHourMatch[2]);
    const period = twelveHourMatch[3];

    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;

    if (period === "AM") {
      if (hours === 12) hours = 0;
    } else {
      if (hours !== 12) hours += 12;
    }

    return hours * 60 + minutes;
  }

  return null;
};

const getActiveSlot = (slots) => {
  const now = new Date();
  const nowMinutes = now.getHours() * 60 + now.getMinutes();

  for (const slot of slots || []) {
    const start = timeToMinutes(slot.start);
    const end = timeToMinutes(slot.end);

    if (start === null || end === null || start === end) continue;

    if (start < end) {
      if (nowMinutes >= start && nowMinutes < end) return slot;
    } else {
      if (nowMinutes >= start || nowMinutes < end) return slot;
    }
  }

  return null;
};

export default function useActiveTimeSlot() {
  const [activeLabel, setActiveLabel] = useState("NO SLOT");

  useEffect(() => {
    let cancelled = false;

    const compute = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const tenant = localStorage.getItem("tenantId");

        if (!token || !tenant) {
          if (!cancelled) setActiveLabel("NO TOKEN/TENANT");
          return;
        }

        const settings = await getTenantSettings(token, tenant);
        const slots = Array.isArray(settings?.timeSlots) ? settings.timeSlots : [];
        const active = getActiveSlot(slots);

        if (!cancelled) {
          setActiveLabel(active?.name || active?.label || "NO SLOT");
        }
      } catch (err) {
        console.error("[useActiveTimeSlot] failed to fetch settings:", err);
        if (!cancelled) setActiveLabel("FETCH ERROR");
      }
    };

    compute();

    const bc = new BroadcastChannel("ws-events");
    const handler = ({ data }) => {
      if (data?.event === "settings_updated") {
        compute();
      }
    };

    bc.addEventListener("message", handler);
    const interval = setInterval(compute, 60000);

    return () => {
      cancelled = true;
      bc.removeEventListener("message", handler);
      bc.close();
      clearInterval(interval);
    };
  }, []);

  return activeLabel;
}